'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = '@@redial-hooks';
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redial/lib/propName.js
 ** module id = 350
 ** module chunks = 0
 **/